import api from "./apiHelper";
import { queryCache } from "react-query";
import { useCustomPaginatedQuery, useCustomQuery } from "hooks/reactQuery";
import { getUserAuthObj } from "../utils/auth";

const jwt = getUserAuthObj();

export const postCreateUser = (payload) => {
  return api.post(`/user/`, payload);
};

export const useGetUsers = (query, onError) => {
  const getUsers = async (key, query) => {
    return api.get(`/user/aggregation`, {
      params: { ...query },
    });
  };
  return useCustomPaginatedQuery("users", getUsers, query, {
    onError,
  });
};

export const useGetUserById = (id, shouldDisplayError, onError) => {
  const getUser = async () => {
    return api.get(`/user/${id}`);
  };

  return useCustomQuery("user", [id], getUser, {
    shouldDisplayError,
    shouldFetch: !!id,
    onError,
  });
};

export const patchUpdateUser = (id, payload) => {
  return api.patch(`/user/${id}`, payload);
};

export const deleteUser = (id) => {
  return api.delete(`/user/${id}`);
};

export const refetchUser = (id) => {
  queryCache.refetchQueries(["user", id]);
};

export const refetchUsers = () => {
  queryCache.refetchQueries("users");
};

export const getAgentContact = (Id) => {
  return api.get(`/user/agent-contact/${Id}`);
};

export const validateBulkCreateUser = (body) => {
  return api.post(`/user/validate-bulk-create-user`, body);
};

export const bulkCreateUser = (body) => {
  return api.post(`/user/bulk-create-user`, body);
};

export const selfSignUpNewUser = (payload) => {
  return api.post(`/user/self-sign-up`, payload);
};
